import { render } from "./App.vue?vue&type=template&id=a6e2c872"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a6e2c872&lang=css"
script.render = render

export default script